import type { OilViscosityParameters } from "../../d";

export function saturatedOilViscosityCalculator(
  params: OilViscosityParameters
): {
  saturatedOilViscosity: number;
} {
  // const deadOilViscosity =
  //   params.deadOilViscosityOverride ||
  //   deadOilViscosityCalculator(params).deadOilViscosity;

  return {
    saturatedOilViscosity: 0
  };
}
